module.exports = __webpack_public_path__ + "static/media/image5.ee541ba8.jpeg";